
<template>
    <Submenu :name="parentItem.name">
        <template slot="title">
            <Icon :type="parentItem.icon"/>
            <span>{{ parentItem.title }}</span>
        </template>
        <template v-for="item in parentItem.children">
            <left-nav-children 
                v-if="item.children&&item.children.length!==0" 
                :parent-item="item" 
            >
            </left-nav-children>
            <menu-item v-else :name="item.name">
                <Icon :type="item.icon"/>
                <span>{{ item.title }}</span>
            </menu-item>
        </template>
    </Submenu>
</template>
<script>
	export default{
		name:'leftNavChildren',
		props: {
			parentItem: {
				type: Object,
				default: () => {}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/left_nav_children.vue